import React from "react";

export default function QuickMenu({ item, routeToPage }) {
  return (
    <div className="flex justify-center items-center cursor-pointer m-2 p-5 md:w-32 w-full bg-white rounded-lg border border-gray-200 hover:shadow-md">
      <div onClick={() => routeToPage(item)}>
        <div>
          <img src={item.iconSvg} alt="icon" className="m-auto" />
        </div>
        <div className="mt-2 font-bold text-center">{item.name}</div>
      </div>
    </div>
  );
}
